export const initialMarkers =
[
    {
      id: 2,
      lat: 27.4300448,
      lng: 89.6627975,
      label: '6 Bed House at Simtokha',
      title: '6 Bed House at Simtokha',
      description: 'Test information for UI',
      specs: {
        bed: 6,
        bath: 2,
        parking: 9
      },
      pricing: {
        price: 700,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 27.4412036,
      lng: 89.6601102,
      label: 'SK House, 4 Bed 4 Bath',
      title: 'SK House, 4 Bed 4 Bath',
      description: 'Test information for UI',
      specs: {
        bed: 4,
        bath: 4,
        parking: 4
      },
      pricing: {
        price: 200,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 27.4504392,
      lng: 89.658013,
      label: '5 Bed Duplex',
      title: '5 Bed Duplex',
      description: 'Test information for UI',
      specs: {
        bed: 5,
        bath: 3,
        parking: 4
      },
      pricing: {
        price: 500,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 27.467498,
      lng: 89.631912,
      title: '3 Bedroom House',
      description: 'Test information for UI',
      specs: {
        bed: 3,
        bath: 2,
        parking: 3
      },
      pricing: {
        price: 1000000,
        for: 'whole lot'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 27.4223668,
      lng: 89.6343153,
      title: '13 Decimal Land',
      description: 'Test information for UI',
      specs: {
        bed: 0,
        bath: 0,
        parking: 0
      },
      pricing: {
        price: 6600,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 26.864072,
      lng:  89.376384,
      title: '3 bed Pent House',
      description: 'Test information for UI',
      specs: {
        bed: 2,
        bath: 1,
        parking: 1
      },
      pricing: {
        price: 8000,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Thimphu',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 26.866594,
      lng: 89.384775,
      title: 'Phuntsoling Core 2 bed Appartment',
      description: 'Test information for UI',
      specs: {
        bed: 2,
        bath: 1,
        parking: 1
      },
      pricing: {
        price: 9900,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Thimphu',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 27.390179,
      lng: 89.618837,
      title:"2 Acre Land for Sale",
      description: 'TTest information for UI',
      specs: {
        bed: 3,
        bath: 1,
        parking: 1
      },
      pricing: {
        price: 30000,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Thimphu',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    }
];

export const filteredMarkers =
[
    {
      id: 9,
      lat: 27.491666662337952,
      lng: 89.72308886926524,
      title: '5 Bed Bungalow',
      description: 'Test information for UI',
      specs: {
        bed: 4,
        bath: 4,
        parking: 4
      },
      pricing: {
        price: 200,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    },
    {
      id: 2,
      lat: 27.4300448,
      lng: 89.6627975,
      title: '6 Bed House',
      description: 'Test information for UI',
      specs: {
        bed: 6,
        bath: 2,
        parking: 9
      },
      pricing: {
        price: 700,
        for: 'per decimal'
      },
      price: 50000,
      address: '20 test lam, TEST Town',
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Thimphu',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    }
  ];

  export const myMarkers = 
  [
    {
      id: 2,
      lat: 27.4504392,
      lng: 89.658013,
      title: 'Yoedsel House',
      description: 'Test information for UI',
      specs: {
        bed: 5,
        bath: 3,
        parking: 4
      },
      pricing: {
        price: 500,
        for: 'per decimal'
      },
      type_id: 2,
      contact: {
        name: 'TA SHI',
        email: 'ttdd@gmail.com',
        phone: 1717272,
        info: 'address, info'
      },
      location: 'Punakha',
      postedBy: 1,
      status_id:1,
      created_on: '2022-12-22 10:15:23',
      ad_type_id: 1
    }
  ];

  export const markerDetails = {
      listing: {
          "id": 22,
          "realtor_names": [
              "TashiW"
          ],
          "realtor_emails": [
              "tttwangchuk@gmail.com"
          ],
          "photos": [],
          "show_names_emails": true,
          "additional_contact_info": "17141619",
          "title": "Spaces for rent",
          "slug": "Spaces-for-rent_1738665952622",
          "latitude": "27.441143",
          "longitude": "89.658506",
          "address": "Chang - Thimphu",
          "city": "Chang - Thimphu",
          "state": "Chang - Thimphu",
          "zipcode": "11001",
          "description": "Spaces for shops, restaurants, stores and office for rent.\r\n\r\n3 Bedrooms flats for rent.\r\n\r\nConvenient location on the express way.",
          "price": 15000,
          "bedrooms": 3,
          "bathrooms": "2.0",
          "sale_type": "For Rent",
          "property_type": "House",
          "is_published": true,
          "date_created": "2025-02-04T10:45:53.281557Z",
          photos: [ 
            { photo :'assets/repics/1.jpg' },
            { photo: 'assets/repics/2.jpg' },
            { photo: 'assets/repics/3.jpg'},
            { photo: 'assets/repics/5.jpg' },
            { photo: 'assets/repics/4.jpg' }
          ]
      }
  };

  export const locations = 
  {
    "Dagana":[
       "Dorona",
       "Drujegang",
       "Gesarling",
       "Goshi",
       "Kana",
       "Karmaling",
       "Khebisa",
       "Lajab",
       "Lhamoy Zingkha",
       "Nichula",
       "Tashiding",
       "Tsangkha",
       "Tsendagang",
       "Tseza"
    ],
    "Gasa":[
       "Goenkhamae",
       "Goenkaatoe",
       "Laya",
       "Lunana"
    ],
    "Punakha":[
       "Chhubu",
       "Dzomo",
       "Goenshari",
       "Guma",
       "Kabjisa",
       "Lingmukha",
       "Shenga Bjime",
       "Talog",
       "Toepisa",
       "Towang"
    ],
    "Tsirang":[
       "Barshong",
       "Dunglegang",
       "Goseling",
       "Kikhorthang",
       "Mendrelgang",
       "Patshaling",
       "Phutenchhu",
       "Rangthangling",
       "Semjong",
       "Sergithang",
       "Tsholingkhar",
       "Tsirangtoe"
    ],
    "Wangdue Phodrang":[
       "Athang",
       "Bjena",
       "Daga",
       "Dangchu",
       "Gangte",
       "Gasetsho Gom",
       "Gasetsho Om",
       "Kazhi",
       "Nahi",
       "Nyisho",
       "Phangyuel",
       "Phobji",
       "Ruepisa",
       "Sephu",
       "Thedtsho"
    ],
    "Bumthang":[
       "Chhume",
       "Choekor",
       "Tang",
       "Ura"
    ],
    "Sarpang":[
       "Chhuzagang",
       "Chhudzom",
       "Dekiling",
       "Gakiling",
       "Gelephu",
       "Jigmechhoeling",
       "Samtenling",
       "Senghe",
       "Serzhong",
       "Shompangkha",
       "Tareythang",
       "Umling"
    ],
    "Trongsa":[
       "Dragteng",
       "Korphu",
       "Langthil",
       "Nubi",
       "Tangsibji"
    ],
    "Zhemgang":[
       "Bardho",
       "Bjoka",
       "Goshing",
       "Nangkor",
       "Ngangla",
       "Phangkhar",
       "Shingkhar",
       "Trong"
    ],
    "Chukha":[
       "Bjacho",
       "Bongo",
       "Chapcha",
       "Dala",
       "Dungna",
       "Geling",
       "Getena",
       "Logchina",
       "Metakha",
       "Phuentsholing",
       "Sampheling"
    ],
    "Haa":[
       "Bji",
       "Gakiling",
       "Katsho",
       "Sama",
       "Sangbay",
       "Uesu"
    ],
    "Paro":[
       "Doga",
       "Dopshari",
       "Doteng",
       "Hungrel",
       "Lamgong",
       "Lungnyi",
       "Naja",
       "Shapa",
       "Tsento",
       "Wangchang"
    ],
    "Samtse":[
       "Dungtoe",
       "Dophoogchen",
       "Denchukha",
       "Namgaychhoeling",
       "Norbugang",
       "Norgaygang",
       "Pemaling",
       "Phuentshogpelri",
       "Samtse",
       "Sangngagchhoeling",
       "Tading",
       "Tashicholing",
       "Tendu",
       "Ugentse",
       "Yoeseltse"
    ],
    "Thimphu":[
       "Chang",
       "Dagala",
       "Genyekha",
       "Kawang",
       "Lingzhi",
       "Mewang",
       "Naro",
       "Soe"
    ],
    "Lhuntse":[
       "Gangzur",
       "Jaray",
       "Khoma",
       "Kurtoe",
       "Menbi",
       "Metsho",
       "Minjay",
       "Tsenkhar"
    ],
    "Mongar":[
       "Balam",
       "Chaskhar",
       "Chhali",
       "Drametse",
       "Drepung",
       "Gongdue",
       "Jurmey",
       "Kengkhar",
       "Mongar",
       "Narang",
       "Ngatshang",
       "Saleng",
       "Sherimung",
       "Silambi",
       "Thangrong",
       "Tsakaling",
       "Tsamang"
    ],
    "Pemagatshel":[
       "Chhimung",
       "Choekhorling",
       "Chongshing Borang",
       "Dechenling",
       "Dungme",
       "Khar",
       "Nanong",
       "Norbugang",
       "Shumar",
       "Yurung",
       "Zobel"
    ],
    "Samdrup Jongkhar":[
       "Dewathang",
       "Gomdar",
       "Langchenphu",
       "Lauri",
       "Martshala",
       "Orong",
       "Pemathang",
       "Phuntshothang",
       "Samrang",
       "Serthi",
       "Wangphu"
    ],
    "Trashigang":[
       "Bartsham",
       "Bidung",
       "Kanglung",
       "Kangpara",
       "Khaling",
       "Lumang",
       "Merak",
       "Phongmey",
       "Radhi",
       "Sakteng",
       "Samkhar",
       "Shongphu",
       "Thrimshing",
       "Uzorong",
       "Yangneer"
    ],
    "Trashiyangtse":[
       "Bumdeling",
       "Jamkhar",
       "Khamdang",
       "Ramjar",
       "Toetsho",
       "Tomzhangsa",
       "Trashiyangtse",
       "Yalang"
    ]
 };
